<template>
  <svg :x="x" :y="y" width="160" height="200" viewBox="0 0 134 151" fill="none" class="svg-tree">
    <g clip-path="url(#clip0)">
      <path d="M24.682 146.987v.4l.9.5-.9-.9z" fill="#000" />
      <path d="M26.582 145.287l-1 .4 3.2 3.2 1.5.1-3.7-3.7z" fill="#000" />
      <path d="M29.082 144.187l-1 .4 4 4 .9-.5-3.9-3.9z" fill="#000" />
      <path d="M31.582 143.087l-1 .4 3.9 3.9 1-.4-3.9-3.9z" fill="#000" />
      <path d="M34.182 141.987l-1 .5 3.8 3.8.9-.5-3.7-3.8z" fill="#000" />
      <path d="M36.682 140.987l-1 .4 3.7 3.7 1-.4-3.7-3.7z" fill="#000" />
      <path d="M39.182 139.887l-1 .4 3.7 3.7.9-.5-3.6-3.6z" fill="#000" />
      <path d="M41.782 138.787l-1 .4 3.5 3.6 1-.5-3.5-3.5z" fill="#000" />
      <path d="M44.282 137.787l-1 .4 3.5 3.4.9-.4-3.4-3.4z" fill="#000" />
      <path d="M46.682 136.587l-.9.5 3.4 3.4.9-.6-3.4-3.3z" fill="#000" />
      <path d="M48.982 135.287l-.9.5 3.4 3.3.8-.5-3.3-3.3z" fill="#000" />
      <path d="M51.382 133.987l-.9.5 3.2 3.3.9-.5-3.2-3.3z" fill="#000" />
      <path d="M53.682 132.687l-.9.5 3.2 3.3.9-.5-3.2-3.3z" fill="#000" />
      <path d="M56.082 131.487l-1 .5 3.2 3.2 1-.5-3.2-3.2z" fill="#000" />
      <path d="M58.382 130.187l-.9.5 3.2 3.2.9-.5-3.2-3.2z" fill="#000" />
      <path d="M60.682 128.987l-.9.5 3.2 3.1.9-.5-3.2-3.1z" fill="#000" />
      <path d="M63.082 127.687l-.9.5 3.1 3.1.9-.5-3.1-3.1z" fill="#000" />
      <path d="M65.382 126.387l-.9.5 3.1 3.1.9-.5-3.1-3.1z" fill="#000" />
      <path d="M67.782 125.187l-1 .5 3.1 3 .9-.5-3-3z" fill="#000" />
      <path
        d="M67.382 121.187h.1l-5.5-5.5-1.1.3 5.6 5.7 2.4 2.4.5.2-.2.1 3 3 .9-.5-5.7-5.7z"
        fill="#000"
      />
      <path
        d="M70.982 121.187h.1l-6.3-6.3-1.1.4 6.4 6.4 8.6 8.6 4.7 3.3-12.4-12.4z"
        fill="#000"
      />
      <path
        d="M74.282 121.187l-7-7-1.1.4 7.1 7.1 13.4 13.4h1.4l-13.8-13.9z"
        fill="#000"
      />
      <path
        d="M77.882 121.187l-13.5-13.5-1.4.1 5.9 5.9 1-.2-.9.3 7.9 7.9 13.5 13.5 1.5.1-14-14.1z"
        fill="#000"
      />
      <path
        d="M81.482 121.187l-13.6-13.5h-1.4l14.1 14h-.1l13.7 13.7h1.5l-14.2-14.2z"
        fill="#000"
      />
      <path
        d="M85.082 121.187l-13.6-13.6h-1.4l14.1 14.1h-.1l12.4 12.4.4-1-11.8-11.9z"
        fill="#000"
      />
      <path d="M97.882 133.987l-.3.9 1.1.2.1-.1-.9-1z" fill="#000" />
      <path d="M98.482 131.087l-.2 1.1 1.4 1.5.6-.8-1.8-1.8z" fill="#000" />
      <path d="M99.182 128.087l-.3 1.2 2.3 2.3.6-.8-2.6-2.7z" fill="#000" />
      <path
        d="M95.882 121.187l-16.7-16.7.6 2 15.2 15.2 7.7 7.8.6-.8-7.4-7.5z"
        fill="#000"
      />
      <path
        d="M99.482 121.187l-20-20-1.2.1v.1l20.3 20.3 5.6 5.7.6-.9-5.3-5.3z"
        fill="#000"
      />
      <path
        d="M105.182 123.287l-2.1-2.1-21.3-21.2-1 .3 21.4 21.4 2.9 3-.3-1.5.4.1z"
        fill="#000"
      />
      <path
        d="M106.682 121.187l-22.2-22.2-1.1.4 22.4 22.3 1.7 1.7 1-.4-1.8-1.8z"
        fill="#000"
      />
      <path
        d="M110.282 121.187l-23.2-23.2-1 .4 23.3 23.3.6.7 1-.4-.7-.8z"
        fill="#000"
      />
      <path d="M53.582 115.687l1-.1-1-1-.3.5h.1l.2.6z" fill="#000" />
      <path d="M58.882 119.787l-2.6-2.5-1.1.3 1.2 1.2 2.5 1z" fill="#000" />
      <path
        d="M59.082 116.487l-1.1.3 4.7 4.7 2.4 1-1.3-1.3h.1l-4.8-4.7z"
        fill="#000"
      />
      <path d="M56.482 115.287l1.3-.1-2.7-2.7-.6.8 2 2z" fill="#000" />
      <path d="M59.682 114.887l1.3-.2-4.4-4.3-.6.8 3.7 3.7z" fill="#000" />
      <path d="M62.882 114.487l1.2-.2-6-6-.6.8 5.4 5.4z" fill="#000" />
      <path d="M60.782 107.787h-1.3l6.2 6.3 1.3-.2-6.2-6.1z" fill="#000" />
      <path
        d="M87.782 121.687h-.1l9.8 9.8.3-.8.1-.2-9.2-9.3-13.5-13.5-.4.1h-.2l-.9-.2 14.1 14.1z"
        fill="#000"
      />
      <path
        d="M91.382 121.687l7.2 7.3.4-1-6.7-6.8-13.8-13.8-1.3.1 14.2 14.2z"
        fill="#000"
      />
      <path d="M112.582 121.287l1-.4-23.1-23.1-1.5-.1 23.6 23.6z" fill="#000" />
      <path d="M115.082 120.187l1-.4-21.8-21.8-1.5-.1 22.3 22.3z" fill="#000" />
      <path d="M117.682 119.187l.6-.3v-.5l-20.1-20.2h-1.5l21 21z" fill="#000" />
      <path d="M118.082 115.987l-.2-1.6-18.2-18.3-.6.9 19 19z" fill="#000" />
      <path
        d="M117.682 111.987l-.1-.8.7-.1-15.4-15.3-1.3.1 16.1 16.1z"
        fill="#000"
      />
      <path d="M120.382 111.087l1.3-.1-15.3-15.3h-1.4l15.4 15.4z" fill="#000" />
      <path
        d="M123.282 110.287l.2-.3.3-.5-14.1-14.2-1.2.3 14.8 14.7z"
        fill="#000"
      />
      <path
        d="M124.582 108.087h.1l.5-.8-12.5-12.6-1.2.3 13.1 13.1z"
        fill="#000"
      />
      <path d="M124.082 103.987l.3-1.1-8.7-8.7-1.2.2 9.6 9.6z" fill="#000" />
      <path
        d="M124.882 101.187l.1-.3.4-.6-6.7-6.7-1.2.2 7.4 7.4z"
        fill="#000"
      />
      <path d="M126.382 99.087l.7-.8-5.4-5.3-1.2.2 5.9 5.9z" fill="#000" />
      <path d="M128.082 97.087l.6-.8-3.9-3.9-1.2.2 4.5 4.5z" fill="#000" />
      <path d="M129.682 95.087l.6-.8-2.5-2.5-1.2.2 3.1 3.1z" fill="#000" />
      <path d="M131.282 93.087l.6-.7-1.1-1.2-1.2.3 1.7 1.6z" fill="#000" />
      <path d="M132.882 91.187l.3-.5-.6.2.3.3z" fill="#000" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.482 146.087l.4-.7 2.4-22.5-.1-6.4s-3.1 27.2-3.1 27.4c.1.3.4 2.2.4 2.2z"
        fill="#896506"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.382 148.387l-1.6-1.7 4-25.3.1-5.1 2.8.2-1.7 19.5-3.6 12.4z"
        fill="#B78448"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.782 148.087l-3.4.2 3.6-23.6.3-6.3 3.7 3.3-3.4 22.8-.8 3.6z"
        fill="#A27327"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.782 122.387l-3 25.8 2.7-2 2.6-24.2.7-35.5-3.4.8.4 35.1z"
        fill="url(#paint0_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.282 118.387l2.5 3.9.2-2.8 1-35.7-2.9.9-1.3 30.7.5 3z"
        fill="url(#paint1_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.982 87.387l-1.1 28.9 1.4 2.2.1-2.6.6-18.3.4-11.9-1.4 1.7z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M33.982 83.887l-.1 2.9 1.9-.5-.6 30.4.1 6.2-2.4 22.5-.4.7-2.7 2-3.4.2-1.6-1.7 4-25.3.1-5.1 1.1-28.9 1.1-1.4.1-1.3 2.8-.7zm0-2c-.2 0-.4 0-.6.1l-2.8.8c-.8.2-1.4 1-1.4 1.8v.6l-.7.9c-.3.3-.4.8-.4 1.2l-1.2 28.9-.1 5-4 25.2c-.1.6.1 1.2.5 1.7l1.6 1.7c.4.4.9.6 1.4.6h.1l3.4-.2c.4 0 .8-.2 1.1-.4l2.7-2c.2-.1.4-.3.5-.5l.4-.7c.2-.3.3-.5.3-.8l2.4-22.5v-.3l-.1-6.1.6-30.3v-.1c0-1.1-.8-1.9-1.9-2v-.4c0-.6-.3-1.2-.8-1.6-.2-.5-.6-.6-1-.6z"
        fill="#231F20"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.782 81.187h3.4v9l-4-1.7.6-7.3z"
        fill="#3DAB60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.882 32.187l5.6-6.4.5 2.6-6.1 3.8z"
        fill="#6AD696"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M53.482 61.987l3.6 2.8 6.7 16.2-5.3-6.8-7.7-10.6-1.9-3.3 4.6 1.7z"
        fill="#1D6320"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.682 63.087l2.7 3.4 9.5 14.5-5.6-6.6-7.9-10.2 1.3-1.1z"
        fill="#2B752F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.282 62.387l2 4.1 10.5 14.5-1 .6-9.4-12.4-7.6-6 5.3-1.6.2.8z"
        fill="url(#paint3_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.882 63.587l1.8 3.7 5.2 8.9 4.4 7-8 7-.4-7.3-3-.5-1.8-1.2-7.9-7.7-.7-6.4 10.4-3.5z"
        fill="url(#paint4_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.682 87.887l9.3.9 14.3 1.4-3.4-7.8-5.7-3.9-8.4-2-6.1 11.4z"
        fill="url(#paint5_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.082 69.887l6.7-6.2-1.6-3.8-8.1 2.4 3 7.6z"
        fill="url(#paint6_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.682 87.887l7.3-9.8-3.9-7.7-6.2 6.6 2.8 10.9z"
        fill="#3DAB60"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.882 77.587l2.2-1.3-1.1-4.6-4.4 1.9 3.3 4z"
        fill="#329346"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.082 69.887l6.8 12.6-1.8 3-11-7.3-5-1.9 4.1-6.2 6.9-.2z"
        fill="url(#paint7_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.782 74.387l2.3 1.9 11-6.4-2.3-9.4-2-13.9s-6 2.8-6.2 3.2c-.2.4-6 13.3-6 13.3l3.2 11.3z"
        fill="url(#paint8_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.382 88.387l.9.7 10-16 1.7-3.3-6.1-.1-6.5 18.7z"
        fill="url(#paint9_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.682 90.487l.7.6 18.6-2.8 9 .6-9.3-.9-19 2.5z"
        fill="#33903E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.382 71.387l3.6 5.2 8.9 1.1-.1-3.3-12.4-8.2v5.2z"
        fill="#3DAF67"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.382 71.387l-11 17.2-5.3-12.5 11.2-11.4 5.1 6.7z"
        fill="#4EBE78"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.082 67.887l7.3 3.4 1.2-3.6-1.3-6.5-7.2 6.7z"
        fill="#45B36E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.282 61.187l-.6 1.2-1 3v.8l3 1.6 9.2 7.8 2-1.1.3-6.7.2-5.4-13.1-1.2z"
        fill="url(#paint10_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.082 67.887l-9 8.2 10.1-10.9 1.7-.9-2.8 3.6z"
        fill="#66D493"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.782 59.687l-3.3 4.7-2.4 3.5 6.6-5.6.9-1.7-1.8-.9z"
        fill="#4BB977"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.782 59.687l-.8 1.1.1 2.1.3-.2 2.3-3.4-1.9.4z"
        fill="url(#paint11_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.282 64.087l15.3-2.4-1.5-9.2-6.6-4.1-3.4-.5-3.8 16.2z"
        fill="#35994C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.282 64.087l2.9-7.1 2.8-6.8-6.7-3-.2 9.2 1.2 7.7z"
        fill="#389F54"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.282 47.287l.6 9 .5 7.8h-.9l-.8-15.9.6-.9z"
        fill="#3EAF67"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.282 47.287l-.2 8.8-.4-7.9.6-.9z"
        fill="url(#paint12_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M57.982 47.287l-10.9-10-2.7 2.5 13.6 7.5z"
        fill="#2F9146"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.282 47.287l6.7 3 6.8 5.1 2.8 6.3 2.4-14.4-12-8.3-9.3 2.2 2.6 6.1z"
        fill="url(#paint13_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.482 62.687l16.7 5 2.1-20.4-13.8 3.1-5 12.3z"
        fill="#3DAD63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.482 62.687l18.8-15.4-13.8 3.1-5 12.3z"
        fill="#45B56E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.282 47.287l-3.6-11.9-1.3-7.5-4.5 1.9-4.8 7.6.5 13 13.7-3.1z"
        fill="#38A75D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.582 52.187l1.7 1.1 11.2-10.6v-5.7l-3.7 1.6-9.2 13.6z"
        fill="url(#paint14_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.782 26.387l5.2 13.4 1.6 5.2.7 2.3-3.2 2.1-.9-1 .2-6.7-.5.5-1.1 5.9-4.4-2.2-2.8-1.9.4-2.1 4.8-15.5z"
        fill="url(#paint15_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.182 53.987l8.9-10.9 7.9 2.2.6 5.2-5.1 12.3-12.3-8.8z"
        fill="#48BB74"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.482 50.387l2.2-11.4-7.9-.8-2.7 4.9 3.3 2.9 5.1 4.4z"
        fill="#42B46C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.182 39.887l2.1 4.2h3.4l1-5-6.5.8z"
        fill="url(#paint16_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.882 42.387l3.7-5.8-.9-1.1-2.8 6.9z"
        fill="#5CCC8A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.582 52.187l8.3-9.8 4-8.2-10.2 8.3-2.1 9.7z"
        fill="#58C684"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.782 27.087l12.4-24.9-2.2 32.9-10.2-8z"
        fill="#4AB773"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.482 28.087l-4.7-1-5 5.1 3.6 7.4 4.8-5.5 1.3-6z"
        fill="#4EBD78"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.482 28.087l5.5-3.3 1.5-2.8 1.3-1.9-.6-17.9-7.7 25.9z"
        fill="#3DAF67"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.482 28.087l-6 11.5 9.6 3.3 1.9-7.8-5.5-7z"
        fill="#45B76F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.982 35.087l1.5-13-7 6.1 5.5 6.9z"
        fill="#43B46C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.882 43.587h.2l1.1-13.9-.6 5.5-.1.9-.6 7.5z"
        fill="#46B56F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.082 42.887l.7-.1 1.7-7.4v.8l.7-6.4.3-7.7-1.5 13-1.9 7.8z"
        fill="url(#paint17_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.082 43.587l13-2 1.5-11.2-9.3 2.2-4.6 2.8-.6 8.2z"
        fill="#3DAC62"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.782 35.387l4.7-.4 4.7-.4-1.7-6-1.7-6-2.7-1.3-2.5.8-.5 6.6-.3 6.7z"
        fill="#37A35A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.682 22.587l-4.5-20.4-.7 19.8 1.8.2 3.4.4z"
        fill="#349F55"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.082 41.487l5.6-6.4-4.1-4.8-4.5 4.3 3 6.9z"
        fill="#38A057"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.082 34.587l4.5-4.2-5.7-9.4-6.7-18.8 4.4 20.4 3.5 12z"
        fill="#2B873E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.082 34.587l-.1-6.9 4.6 2.7-4.5 4.2z"
        fill="#33924A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.582 30.387l4.9 3.8-.9.8-4-4.6z"
        fill="url(#paint18_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.482 34.187l-2.2-4.7-1.1-2.3-4-1.8 2.4 5 4.9 3.8z"
        fill="#41AB62"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.182 25.387l-3.5-4.9.2.5 5.7 9.4-2.4-5z"
        fill="#38994F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.382 25.787l4.8 3.7 1.5 3.3-4.1-2.4-2.2-4.6z"
        fill="#2F8D46"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.382 71.387l-6.7 19.1 19.1-2.6.1-6.6.1-3.7-10.1-5-2.5-1.2z"
        fill="#46B870"
      />
      <path
        d="M34.182 2.187l6.7 18.8-.2-.5 3.5 4.9 4 1.8 1.1 2.3 2.2 4.7-.9.8.1.2-2.7 3 9.9 9-2.4 14.4-2.1.3 3.6 2.8 6.7 16.2-1 .6-8.2-10.8 3.2 5.5 4.4 7-8 7-14.3-1.3-9-.6-18.6 2.8-.7-.6 5.6-15.6-8.8 14.2-.9-.6-.1.1-5.2-12.5 10.1-10.9 1.2-.6.1-.2 2.5-3.5.6-.9-8.4-6 1.1-1.3-.7-.5 2.1-9.6 8-6.5-1.8-3.9 5.6-6.3 11.7-23.7zm0-2c-.8 0-1.5.4-1.8 1.1l-11.6 23.4-5.4 6.1c-.5.6-.7 1.5-.3 2.2l1.1 2.4-6.8 5.5c-.3.3-.6.7-.7 1.1l-2.1 9.6c-.1.3-.1.7 0 1-.3.4-.5 1-.4 1.5.1.5.4 1 .8 1.4l6.8 4.9-1.7 2.6-.8.4c-.2.1-.4.2-.5.4l-10.2 10.9c-.5.6-.6 1.5-.3 2.2l5.2 12.4c.2.6.8 1 1.4 1.2l.2.2c.3.2.7.4 1.2.4h.4c.4-.1.7-.3 1-.5 0 .6.2 1.1.7 1.5l.7.6c.4.3.8.5 1.3.5h.3l18.4-2.9 8.8.5 14.2 1.4h.2c.5 0 .9-.2 1.3-.5l8-7c.5-.4.8-1.1.7-1.8l.5-.3c.5-.3.8-.8 1-1.3v-.1c.1-.3 0-.7-.1-1.1l-6.7-16.2c-.1-.3-.4-.6-.6-.8l-.9-.7c.1-.2.1-.3.1-.5l2.4-14.4c.1-.7-.1-1.4-.6-1.8l-8.4-7.7 1.4-1.6c.2-.2.3-.4.4-.6l.2-.2c.7-.6.9-1.6.5-2.4l-2.4-4.6-1.1-2.3c-.2-.4-.6-.8-1-1l-3.5-1.6-3.1-4.3-6.3-17.9c-.3-.8-1-1.3-1.8-1.3h-.1z"
        fill="#231F20"
      />
      <path
        d="M16.882 32.187l3.6 7.4 9.6 3.3 2.4-8.7.7-7.1v16.3l11.9-1.9 6.4-7.3"
        stroke="#231F20"
        stroke-width="2"
        stroke-miterlimit="100"
        stroke-linecap="round"
      />
      <path
        d="M8.182 53.987l12.3 8.7 16.6 5 1.6-16.5.3 1 .4 11.9 16.2-2.4"
        stroke="#231F20"
        stroke-width="2"
        stroke-miterlimit="100"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="30.922"
        y1="144.862"
        x2="35.112"
        y2="84.928"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#826126" />
        <stop offset=".28" stop-color="#7C4C1E" />
        <stop offset=".51" stop-color="#834D1F" />
        <stop offset="1" stop-color="#85481F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="30.921"
        y1="118.305"
        x2="33.039"
        y2="88.004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8A5823" />
        <stop offset="1" stop-color="#835422" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="30.867"
        y1="115.925"
        x2="29.51"
        y2="90.021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8B622B" />
        <stop offset="1" stop-color="#845C29" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="50.145"
        y1="64.469"
        x2="56.801"
        y2="72.689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#215429" />
        <stop offset="1" stop-color="#204821" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="52.062"
        y1="79.022"
        x2="47.712"
        y2="70.839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#17562B" />
        <stop offset="1" stop-color="#266231" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="37.759"
        y1="92.303"
        x2="44.986"
        y2="83.988"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3D9C57" />
        <stop offset="1" stop-color="#3E9B54" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="45.956"
        y1="62.973"
        x2="47.464"
        y2="67.616"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#216030" />
        <stop offset="1" stop-color="#276733" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="47.495"
        y1="82.915"
        x2="39.339"
        y2="73.856"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1D5C2E" />
        <stop offset=".39" stop-color="#246C36" />
        <stop offset="1" stop-color="#297239" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="39.444"
        y1="71.823"
        x2="33.561"
        y2="55.658"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2A743A" />
        <stop offset=".37" stop-color="#236834" />
        <stop offset="1" stop-color="#1A3C1C" />
      </linearGradient>
      <linearGradient
        id="paint9_linear"
        x1="8.304"
        y1="80.305"
        x2="20.073"
        y2="76.252"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#308A43" />
        <stop offset="1" stop-color="#196332" />
      </linearGradient>
      <linearGradient
        id="paint10_linear"
        x1="22.681"
        y1="69.724"
        x2="27.552"
        y2="64.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#237C3E" />
        <stop offset="1" stop-color="#20733A" />
      </linearGradient>
      <linearGradient
        id="paint11_linear"
        x1="17.132"
        y1="60.704"
        x2="16.657"
        y2="62.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#287A43" />
        <stop offset="1" stop-color="#277E45" />
      </linearGradient>
      <linearGradient
        id="paint12_linear"
        x1="39.052"
        y1="49.585"
        x2="39.202"
        y2="52.432"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#17411D" />
        <stop offset="1" stop-color="#155229" />
      </linearGradient>
      <linearGradient
        id="paint13_linear"
        x1="51.447"
        y1="53.102"
        x2="44.887"
        y2="39.652"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#32803E" />
        <stop offset=".67" stop-color="#29793C" />
        <stop offset="1" stop-color="#196131" />
      </linearGradient>
      <linearGradient
        id="paint14_linear"
        x1="8.806"
        y1="50.645"
        x2="18.933"
        y2="41.525"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2E8C47" />
        <stop offset="1" stop-color="#288341" />
      </linearGradient>
      <linearGradient
        id="paint15_linear"
        x1="32.888"
        y1="47.606"
        x2="33.728"
        y2="31.562"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#297F3F" />
        <stop offset="1" stop-color="#17381B" />
      </linearGradient>
      <linearGradient
        id="paint16_linear"
        x1="23.338"
        y1="43.105"
        x2="24.91"
        y2="40.268"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#237C3E" />
        <stop offset="1" stop-color="#20733A" />
      </linearGradient>
      <linearGradient
        id="paint17_linear"
        x1="32.176"
        y1="32.22"
        x2="28.596"
        y2="40.261"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#184E26" />
        <stop offset="1" stop-color="#207038" />
      </linearGradient>
      <linearGradient
        id="paint18_linear"
        x1="50.746"
        y1="34.323"
        x2="47.027"
        y2="30.974"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2F8C45" />
        <stop offset="1" stop-color="#207038" />
      </linearGradient>
      <clipPath id="clip0">
        <path
          fill="#fff"
          transform="translate(0.0820312 0.187256)"
          d="M0 0h133.1v150.2H0z"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 500,
    },
  },
}
</script>

<style lang="scss" scoped></style>
